import React from 'react';
import '../assets/styles/components/ProgessTitle.sass';

const ProgessTitle = ({step1 = null, step2 = null, step3 = null, step4 = null, city}) => (
  <div className="row">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <ul className={`ProgessTitle --${city}`}>
            <li className={step1}>1. SELECCIONE CATEGORÍA Y MERCANCÍA</li>
            <li className={step2}>2. INFO DEL CORREDOR</li>
            <li className={step3}>3. REVISE SU INFO</li>
            <li className={step4}>4. PAGO</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default ProgessTitle;
